import { createContext, useContext } from "react";
import { MapEditorToolState } from "./MapEditorContext.types";

export const MapEditorToolContext = createContext<MapEditorToolState | null>(
  null
);

export const useMapEditorTool = (): MapEditorToolState => {
  const context = useContext(MapEditorToolContext);
  if (!context) {
    throw new Error("useMapEditorTool must be used within a MapEditorProvider");
  }
  return context;
};
